import type { dashboardWidgetRegistry } from '@/components/dashboard/DashboardCanvas';
import { PublisherInventoryRenderer } from './PublisherInventoryRenderer';
import { PublisherMetricRenderer } from './PublisherMetricRenderer';
import { PublisherPerformanceRenderer } from './PublisherPerformanceRenderer';
import type { PublisherDashboardRuntime } from './widgetRuntime';
import {
  publisherInventoryWidgetSchema,
  publisherMetricWidgetSchema,
  publisherPerformanceChartWidgetSchema,
  PublisherDashboardWidgetType,
  type PublisherDashboardWidget,
} from './widgetModel';

export const publisherDashboardWidgetRegistry: dashboardWidgetRegistry<
  PublisherDashboardWidget,
  PublisherDashboardRuntime
> = {
  [PublisherDashboardWidgetType.Metric]: {
    schema: publisherMetricWidgetSchema,
    component: PublisherMetricRenderer,
    twoPerMobileRow: true,
  },
  [PublisherDashboardWidgetType.PerformanceChart]: {
    schema: publisherPerformanceChartWidgetSchema,
    component: PublisherPerformanceRenderer,
  },
  [PublisherDashboardWidgetType.Inventory]: {
    schema: publisherInventoryWidgetSchema,
    component: PublisherInventoryRenderer,
  },
};
